/**
 * チュートリアルサービス
 * 複数のコントローラーで共通利用できるチュートリアル関連機能を提供
 * headerCtrlの既存実装を汎用化したもの
 */
angular.module('inspinia').service('tutorialService', [
  '$http',
  '$state',
  '$modal',
  '$timeout',
  function ($http, $state, $modal, $timeout) {
    /**
     * チュートリアルデータを初期化（headerCtrlのsetTutorial実装）
     * @param {Object} scope - コントローラーのスコープ
     * @param {boolean} shouldExpand - チュートリアルを展開するか
     */
    this.setTutorial = function (scope, shouldExpand) {
      // 既に初期化済みで有効な場合はスキップ（冪等性を保つ）
      if (scope.tutorial && scope.tutorial.on) {
        return;
      }

      // 設定もしくは園児台帳の権限をもっている場合に表示
      if (scope.checkAuthority('setting')) {
        if (scope.services.attributes && scope.services.attributes.tutorial_onboarding) {
          scope.tutorial = angular.fromJson(scope.services.attributes.tutorial_onboarding);

          if (scope.tutorial.on) {
            if (shouldExpand) {
              scope.tutorial.tutorial_expand = true;
            } else {
              scope.tutorial.tutorial_expand = false;
            }

            scope.tutorial.never_view_flag = false;

            this.checkTutorialStepComplete(scope);
            // 既存UIでは初期化時にshowTutorialTextの呼び出しが必要
            if (scope.showTutorialText) {
              scope.showTutorialText($state.current);
            }
          }
        } else {
          scope.tutorial = {};
          scope.tutorial.on = false;
        }
      } else {
        scope.tutorial = {};
        scope.tutorial.on = false;
      }
    };

    /**
     * チュートリアルの完了数をカウント（headerCtrl実装）
     */
    this.checkTutorialStepComplete = function (scope) {
      let count = 0;
      angular.forEach(scope.tutorial.steps, function (step) {
        if (step.complete) {
          count++;
        }
      });
      scope.tutorial.complete_count = count;
    };

    /**
     * チュートリアルのステップを完了（headerCtrl実装）
     */
    this.completeTutorialStep = function (scope, step, index, is_advance, is_toggle) {
      if (!step.complete) {
        step.complete = true;
        if (angular.isUndefined(step.complete_count)) {
          step.complete_count = 0;
        }
        step.complete_count++;
      } else {
        if (is_toggle) {
          step.complete = false;
        }
      }

      step.complete_administrator_id = scope.my.id;
      step.complete_datetime = scope.getFormattedDatetime();
      this.checkTutorialStepComplete(scope);
      this.updateTutorial(scope);
      if (step.complete) {
        if (is_advance) {
          // do nothing now
        } else {
          scope.serverService.message(scope.system.array_tutorial_step_complete_message[scope.tutorial.type][index]);
        }
      }
    };

    /**
     * チュートリアル状態を保存（headerCtrl実装）
     */
    this.updateTutorial = function (scope) {
      scope.tutorial.update_administrator_id = scope.my.id;
      scope.tutorial.update_datetime = scope.getFormattedDatetime();

      const params = {};
      params['mode'] = 'update_tutorial_attributes_' + scope.tutorial.type;
      const obj = angular.copy(scope.tutorial);
      if (scope.tutorial.never_view_flag) {
        obj.on = false;
      }
      params['attributes.tutorial_' + scope.tutorial.type] = angular.toJson(obj);

      const service_id = scope.my.current_service_id ? scope.my.current_service_id : scope.my.service_id;

      $http
        .put(scope.serverService.apiEndPoint + 'services/' + service_id, params)
        .success(function (data, status, headers, config) {
          scope.getService(service_id, true);
        })
        .error(function (data, status, headers, config) {
          scope.serverService.errorCallback(scope, data, status, headers, config);
        });
    };

    /**
     * 今後表示しないフラグの変更（headerCtrl実装）
     */
    this.changeNeverViewFlag = function (scope, $modal) {
      if (scope.tutorial.never_view_flag) {
        // 一旦OFFにする
        scope.tutorial.never_view_flag = false;
        const title = 'チュートリアルを非表示にしてよろしいですか？';
        const message =
          '<strong>運用開始に向けてやるべきことをご案内しているため、実際に運用を開始するまでは表示させておくことをお勧めしております。</strong><br>また、非表示にすると、同じ施設の他の職員の方の画面にも、今後チュートリアルが表示されなくなります。よろしいですか？<br><br>再度表示したい場合は、画面右上の「ヘルプ > チュートリアル」から再スタートできます。<br>変更は、次回画面遷移後より適用されます。';
        const callback = () => {
          // 確認OKであれば改めてONにする
          scope.tutorial.never_view_flag = true;
          delete scope.tutorial.tutorial_title;
          delete scope.tutorial.tutorial_description;
          delete scope.tutorial.show_tutorial_text;
          delete scope.tutorial.manual_link;
          this.updateTutorial(scope);
        };
        scope.serverService.confirm(scope, $modal, title, message, callback);
      } else {
        this.updateTutorial(scope);
      }
    };

    /**
     * チュートリアルステップの順序を正規化
     * attributes テーブルの name='tutorial_onboarding' が存在する施設はステップが上書きされるケースが存在する
     * もしその対象が発生した場合は、園児台帳と職員管理のチュートリアルなどが順番が入れ替わることがあるため
     * ここで正しい順番に並び替える
     * @param {Array} steps - チュートリアルのステップ配列
     * @returns {Array} - 正しい順序に並び替えられたステップ配列
     */
    this.normalizeStepOrder = function (steps) {
      if (!steps || steps.length < 0) {
        return [];
      }

      const correctOrder = [
        'service_setting',
        'service_setting_class',
        'contactbook_list',
        'service_setting_administrator',
      ];

      // ステップをキーでマップ化
      const stepMap = {};
      steps.forEach((step) => {
        stepMap[step.key] = step;
      });

      // 正しい順序で再構築
      const normalizedSteps = [];
      correctOrder.forEach((key) => {
        if (stepMap[key]) {
          normalizedSteps.push(stepMap[key]);
        }
      });

      // 正しい順序にないステップがあれば末尾に追加
      steps.forEach((step) => {
        if (correctOrder.indexOf(step.key) === -1) {
          normalizedSteps.push(step);
        }
      });

      return normalizedSteps;
    };

    /**
     * 指定されたステップキーに対応するチュートリアル情報を取得
     * @param {Object} tutorial - チュートリアルオブジェクト
     * @param {string} stepKey - ステップキー
     * @returns {Object|null} - { step, index, isVisible } または null
     */
    this.getTutorialStepInfo = function (tutorial, stepKey) {
      if (!tutorial || !tutorial.on) {
        return null;
      }

      if (!tutorial.steps || tutorial.steps.length < 0) {
        return null;
      }

      const steps = this.normalizeStepOrder(tutorial.steps);
      const currentStep = steps.find((step) => step.key === stepKey);

      if (!currentStep) {
        return null;
      }

      return {
        step: currentStep,
        index: steps.findIndex((step) => step.key === stepKey),
        isVisible: !currentStep.complete,
        normalizedSteps: steps,
      };
    };

    return this;
  },
]);
